import { Routes } from '@angular/router';
import { AuthGuard } from '../../guard/auth-guard/auth.guard';
import { RoleChildGuard } from '../../guard/auth-guard/role-child.guard';
import { Role } from '../../core/enums/role.enum';

export const recursoMunicipioRoutes: Routes = [
  {
    path: 'recurso-municipio',
    canActivate: [AuthGuard],
    canActivateChild: [RoleChildGuard],
    children: [
      {
        path: '',
        loadComponent: () =>
          import('./recurso-municipio.component').then(
            (m) => m.RecursoMunicipioComponent,
          ),
        data: {
          title: 'Interposição de Recurso Município',
          roles: [Role.INTERPOSICAO_RECURSO_MUNICIPIO_CONSULTAR],
          breadcrumb: [{ label: 'Recurso Município', url: '/recurso-municipio' }],
        },
      },
      {
        path: 'cadastrar',
        loadComponent: () =>
          import('./recurso-municipio-cadastro/recurso-municipio-cadastro.component').then(
            (m) => m.RecursoMunicipioCadastroComponent,
          ),
        data: {
          title: 'Abertura de Interposição de Recurso Município',
          roles: [Role.INTERPOSICAO_RECURSO_MUNICIPIO_CADASTRAR],
          breadcrumb: [
            { label: 'Recurso Município', url: '/recurso-municipio' },
            { label: 'Cadastrar', url: '/recurso-municipio/cadastrar' },
          ],
        },
      },
      {
        path: 'editar/:id',
        loadComponent: () =>
          import('./recurso-municipio-cadastro/recurso-municipio-cadastro.component').then(
            (m) => m.RecursoMunicipioCadastroComponent,
          ),
        data: {
          title: 'Editar a Abertura de Interposição de Recurso Município',
          roles: [Role.INTERPOSICAO_RECURSO_MUNICIPIO_EDITAR],
          breadcrumb: [
            { label: 'Recurso Município', url: '/recurso-municipio' },
            { label: 'Editar', url: '/recurso-municipio/editar' },
          ],
        },
      },
      {
        path: 'visualizar/:id',
        loadComponent: () =>
          import('./recurso-municipio-cadastro/recurso-municipio-cadastro.component').then(
            (m) => m.RecursoMunicipioCadastroComponent,
          ),
        data: {
          title: 'Visualizar Período de Recurso Município',
          roles: [Role.INTERPOSICAO_RECURSO_MUNICIPIO_VISUALIZAR],
          breadcrumb: [
            { label: 'Recurso Município', url: '/recurso-municipio' },
            { label: 'Visualizar', url: '/recurso-municipio/visualizar' },
          ],
        },
      },
      {
        path: 'analisar/:id',
        loadComponent: () =>
          import('./recurso-municipio-analise/recurso-municipio-analise.component').then(
            (m) => m.RecursoMunicipioAnaliseComponent,
          ),
        data: {
          title: 'Análise do Recurso Município',
          roles: [Role.INTERPOSICAO_RECURSO_MUNICIPIO_ANALISAR],
          breadcrumb: [
            { label: 'Recurso Município', url: '/recurso-municipio' },
            { label: 'Análise', url: '/recurso-municipio/analisar' },
          ],
        },
      },
      {
        path: 'analisar-solicitacao/:id',
        loadComponent: () =>
          import('./recurso-municipio-solicitacao-analise/recurso-municipio-solicitacao-analise.component').then(
            (m) => m.RecursoMunicipioSolicitacaoAnaliseComponent,
          ),
        data: {
          title: 'Análise da Solicitação de Recurso Município',
          roles: [Role.INTERPOSICAO_RECURSO_MUNICIPIO_ANALISAR],
          breadcrumb: [
            { label: 'Recurso Município', url: '/recurso-municipio' },
            { label: 'Análise da Solicitação', url: '/recurso-municipio/analisar-solicitacao' },
          ],
        },
      },
    ],
  },
];
